import React, { useMemo } from 'react';
import pathOrDash from 'App/utils/pathOrDash';
import { useFormikContext } from 'formik';
import Table from 'App/components/Table/Table';
import TherigyInfoMessage from 'App/components/TherigyInfoMessage/TherigyInfoMessage';
import { hasLength } from 'App/utils';
import CopayAmountCell from './CopayAmountCell';
import CopayPercentCell from './CopayPercentCell';
import RequiredTableHeaderLabel from 'Shared/form/RequiredTableHeaderLabel';

const MedicationTableForm = () => {
    const { values } = useFormikContext();

    const columns = useMemo(
        () => [
            {
                Header: 'Medication',
                accessor: 'medication.name',
                Cell: ({ row }) => pathOrDash(['original', 'medication', 'name'], row),
                id: 'medication',
                disableFilters: true,
                canSort: true,
                width: '50%',
            },
            {
                Header: <RequiredTableHeaderLabel label="Copay Amount" fieldName="referralBiCopayAmt" />,
                accessor: 'data.copayAmount',
                Cell: CopayAmountCell,
                id: 'copayAmount',
                disableFilters: true,
                canSort: true,
            },
            {
                Header: <RequiredTableHeaderLabel label="Coinsurance Amount" fieldName="referralBiCoinsuranceAmt" />,
                accessor: 'data.copayPercent',
                Cell: CopayPercentCell,
                id: 'copayPercent',
                disableFilters: true,
                canSort: true,
            },
        ],
        []
    );

    if (!hasLength(values?.medications)) {
        return (
            <TherigyInfoMessage message="There is currently no medication attached to this Benefits Investigation Activity." />
        );
    }

    return (
        <>
            <h3>Medication</h3>
            <Table enablePagination={false} columns={columns} data={values?.medications || []} canSort={false} />
        </>
    );
};

export default MedicationTableForm;
